var _defs, _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSketch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.412,
    height: 52.177,
    viewBox: "0 0 66.412 52.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:url(#c);}.d{fill:url(#d);}.e{fill:url(#e);}.f{fill:url(#h);}.g{fill:url(#i);}.h{fill:url(#j);}.i{fill:url(#k);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.59,
    y1: 0.596,
    x2: 0.891,
    y2: 0.802,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.171,
    y1: 0.179,
    x2: 0.77,
    y2: 0.838,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.613,
    y1: 0.691,
    x2: -0.193,
    y2: -0.142,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.309,
    y1: 0.279,
    x2: 0.743,
    y2: 1.059,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -2.311,
    y1: 11.994,
    x2: -1.34,
    y2: 11.994,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc0d5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0.632,
    y1: 0.632,
    x2: 0.311,
    y2: 0.311,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -6.327,
    y1: 41.987,
    x2: -5.452,
    y2: 41.987,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.839,63.322c-.044-.386-.709-.505-.983-.179a24.592,24.592,0,0,0-1.515,2.014.9.9,0,0,1-1.349.031c-3.463-4.45-7.61-10.528-12.067-10.528-7.1,0-13.415,10.933-17.431,19.424a1.924,1.924,0,0,1-3.217-.018l-.023-.053a.8.8,0,0,0-1.363.031C.23,78.718-2.621,90.206,5.305,99.017c3.886,4.7,10.769,7.819,18.619,7.819a25.654,25.654,0,0,0,15.9-5.167c1.807-1.651,8.277-6.288,8.277-16.365,0-13.011-7.631-16.531-8.258-21.983Z",
    transform: "translate(0 -54.66)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38.856,63.143a24.592,24.592,0,0,0-1.515,2.014.9.9,0,0,1-1.349.031c-3.463-4.45-7.61-10.528-12.067-10.528-7.1,0-13.415,10.933-17.431,19.424a1.924,1.924,0,0,1-3.217-.018l-.023-.053a.8.8,0,0,0-1.363.031C.23,78.718-2.62,90.206,5.306,99.017c3.886,4.7,10.769,7.819,18.619,7.819a25.654,25.654,0,0,0,15.9-5.167c1.807-1.651,8.277-6.288,8.277-16.365,0-13.011-7.631-16.532-8.258-21.983-.044-.386-.709-.505-.984-.179Z",
    transform: "translate(0 -54.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M316.868,82.652a.052.052,0,0,0-.1-.024c-.042.067-.094.157-.15.27a.075.075,0,0,1-.133,0c-.342-.6-.752-1.41-1.193-1.41-.7,0-1.391,1.427-1.723,2.6-.837,2.962.947,4.388,1.723,4.388a2.138,2.138,0,0,0,1.571-.692,3.046,3.046,0,0,0,.818-2.192C317.684,83.854,316.93,83.383,316.868,82.652Z",
    transform: "translate(-272.548 -77.998)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M90.891,130.8c-7.764,0-14.059,17.475-14.059,24.348s6.294,12.445,14.059,12.445,14.059-5.572,14.059-12.445S98.655,130.8,90.891,130.8Z",
    transform: "translate(-66.827 -120.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M126.8,225.8c0,4.992-4.572,9.04-10.212,9.04s-10.212-4.047-10.212-9.04,4.572-17.686,10.212-17.686S126.8,220.808,126.8,225.8Z",
    transform: "translate(-92.523 -188.132)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M27.98,160.54c-.836,0-1.513,2.512-1.513,3.5a1.669,1.669,0,0,0,1.513,1.789,1.669,1.669,0,0,0,1.513-1.789C29.494,163.052,28.816,160.54,27.98,160.54Z",
    transform: "translate(-23.02 -146.752)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1.669,
    cy: 1.669,
    r: 1.669,
    transform: "translate(37.307 3.652)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.352 0.518)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M176.734,270.249l-4.417,12.356-.2,3.576c-.272.762,3.6-.173,3.6-.173l12.356-4.417C191.218,278.451,179.875,267.108,176.734,270.249Z",
    transform: "translate(-171.046 -242.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M246.376,70.624,218.988,98.01a3.646,3.646,0,0,0-1.387-1.352,4.3,4.3,0,0,0-3.012.064.378.378,0,0,1-.449-.518,0,0,0,0,0,0,0,3.668,3.668,0,0,0,.13-.346l.05-.168a.019.019,0,0,0,0-.01,3.488,3.488,0,0,0,.1-.544c.006-.06.01-.122.014-.182q.008-.15,0-.3a3.539,3.539,0,0,0-.686-1.985,3.6,3.6,0,0,0-.766-.766,3.543,3.543,0,0,0-2.285-.683c-.06,0-.122.008-.182.014a3.446,3.446,0,0,0-.544.1.019.019,0,0,0-.01,0l-.168.05c-.06.019-.118.039-.176.062s-.112.043-.168.068c0,0,0,0,0,0a.377.377,0,0,1-.517-.449,4.29,4.29,0,0,0,.064-3.01,3.623,3.623,0,0,0-1.352-1.389l27.387-27.389a2.193,2.193,0,0,1,3.1,0l1.617,1.617,5.012,5.012,1.617,1.617a2.193,2.193,0,0,1,0,3.1Z",
    transform: "translate(-201.958 -58.637)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M254.686,80.99,224.07,111.606a.372.372,0,0,1,0-.319,0,0,0,0,0,0,0,8.212,8.212,0,0,0,.282-1.068c.008-.062.012-.122.014-.182a3.544,3.544,0,0,0-.683-2.286,3.6,3.6,0,0,0-.766-.766,3.543,3.543,0,0,0-2.286-.683c-.06,0-.12.006-.182.014a3.108,3.108,0,0,0-.544.1.019.019,0,0,0-.01,0c-.056.014-.455.155-.511.18,0,0,0,0,0,0a.372.372,0,0,1-.319,0l30.616-30.616Z",
    transform: "translate(-211.884 -73.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M167.206,370.212a7.9,7.9,0,0,0-1.967-1.437l-1.212,3.391a.959.959,0,0,0,1.225,1.225l3.391-1.212A7.887,7.887,0,0,0,167.206,370.212Z",
    transform: "translate(-163.969 -328.389)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.033dcb5d359111d11e649dadb5783894.svg";
export { ForwardRef as ReactComponent };